import { render, staticRenderFns } from "./PageViewsStatistics.vue?vue&type=template&id=abe6d0a6&scoped=true&"
import script from "./PageViewsStatistics.vue?vue&type=script&lang=js&"
export * from "./PageViewsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe6d0a6",
  null
  
)

export default component.exports